import { HttpClient } from "@angular/common/http";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { query } from "@angular/animations";
import { IResult } from "app/common/interfaces";
import { ICreateUnitMeasure } from "app/modules/components/material/material/interfaces/create-unit-measure.interface";
import { IUpdateMaterial } from "app/modules/components/material/material/interfaces/update-material.interface";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import BusinessPartnerDistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-dchain/business-partners-dchain.entity";
import { ICreateBusinessPartnerChain } from "./interfaces/create-distribution-chain.interface";
import { IUpdateBusinessPartnerChain } from "./interfaces/update-distribution-chain.interface";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business_partner_distribution_chain";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerDistributionService extends AbstractService<
BusinessPartnerDistributionChainAttributes,
ICreateBusinessPartnerChain,
IUpdateBusinessPartnerChain
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string): Observable<IResult<BusinessPartnerDistributionChainAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}`;
    return this.http.get<IResult<BusinessPartnerDistributionChainAttributes>>(API_URL);
  }
}